import { log } from 'helper/debug';
import appConfig from 'helper/mapBackendConfig';

export const getPlatform = () => appConfig.platform;
export const getPlatformOS = () => appConfig.platformOS;
export const isNativePlatform = (): boolean => getPlatform() === 'native';
export const isNativePlatformIOS = (): boolean => isNativePlatform() && getPlatformOS() === 'ios';
export const isNativePlatformAndroid = (): boolean => isNativePlatform() && getPlatformOS() === 'android';
export const isWebPlatform = (): boolean => getPlatform() === 'web';

export type PlatformComponentProps = {
	children?: any;
};

/*
 * Renders the children only in the Web
 * @param {Object}
 */
const WebPlatformComponent = ({ children }: PlatformComponentProps) => {
	if (!isWebPlatform()) {
		return null;
	}

	return children;
};

/*
 * Renders the children only on native devices (App)
 * @param {Object}
 */
const NativePlatformComponent = ({ children }: PlatformComponentProps): React.ReactNode => {
	if (!isNativePlatform()) {
		return null;
	}

	return children;
};

/*
 * Direct react children I/O
 * @param {Object}
 */
const AllPlatformsComponents = ({ children }: PlatformComponentProps) => children;

/*
 * Debug the current platform information
 */
const PlatformDebugger = () => {
	log(`React App is running on ${getPlatform()} platform`);
	return null;
};

export default {
	getPlatform,
	isNativePlatform,
	isNativePlatformIOS,
	isNativePlatformAndroid,
	isWebPlatform,
};

export { AllPlatformsComponents, WebPlatformComponent, NativePlatformComponent, PlatformDebugger };
